import { useContext } from 'react';
import { createContext } from 'react';

import { NotFoundProps } from '../@types/NotFoundProps';
import NotFoundContainer from '../handles/NotFoundContainer';

export const NotFoundContext = createContext<NotFoundProps>({} as NotFoundProps);

NotFoundContext.displayName = 'NotFound';

const NotFoundProvider = (props: NotFoundProps) => (
	<NotFoundContext.Provider value={props}>
		<NotFoundContainer />
	</NotFoundContext.Provider>
);

export const useNotFound = () => {
	const context = useContext(NotFoundContext);

	return context;
};

export default NotFoundProvider;
